import Hammer from 'hammerjs'

let mc

const drag = {
  bind: function (el, binding) {
    initHammer(el)
  },
  updete: function (el, binding) {
    console.log(el)
    initHammer(el)
  },
  unbind: function (el) {
    initHammer(el, true)
  }
}

function initHammer(el, destory) {
  if (mc) {
    mc.off('panstart panmove pinchmove pinchstart pinchout')
    mc = null
    if (destory) return
  }

  let oEle = el
  let disX, disY, winWidth, imgW, imgH, wrapW, wrapH, sX, sY
  oEle.style.transform = 'scale(1) rotate(0deg)'

  const handler = function (e) {
    switch (e.type) {
      case 'panstart':
        sX = Number(oEle.style.left.replace('px', '')) || 0
        sY = Number(oEle.style.top.replace('px', '')) || 0
        break
      case 'panmove':
        disX = e.deltaX + sX
        disY = e.deltaY + sY
        if (disX >= winWidth - 50) disX = winWidth - 50
        if (disY >= 150) disY = 150
        if (disX <= -wrapW) disX = -wrapW
        if (disY <= -wrapH) disY = -wrapH
        oEle.style.left = disX + 'px'
        oEle.style.top = disY + 'px'
        break
      case 'pinchin':
      case 'pinchout':
        oEle.style.transform = oEle.style.transform.replace(/\d+\.?\d*(?=\))/, e.scale)
        break
      default:
        break
    }
  }

  mc = new Hammer(oEle)

  if (window.innerWidth) {
    winWidth = window.innerWidth
  } else if ((document.body) && (document.body.clientWidth)) {
    winWidth = document.body.clientWidth
  }
  oEle.onload = function () {
    oEle.width = winWidth
    imgW = oEle.width
    imgH = oEle.height
    wrapW = imgW - 50
    wrapH = imgH - 50
  }
  mc.get('pan').set({threshold: 1})
  mc.get('pinch').set({ enable: true })
  mc.on('panstart panmove pinchmove pinchstart  pinchout', handler)
}

export default drag



// WEBPACK FOOTER //
// ./src/utils/drag.js